import Swal from 'sweetalert2';

export const showError = (title: string, text?: string) =>
  Swal.fire({
    icon: 'error',
    title,
    text,
    confirmButtonText: 'Fermer',
    confirmButtonColor: '#dc2626',
  });

export const showSuccess = (title: string, text?: string) =>
  Swal.fire({
    icon: 'success',
    title,
    text,
    confirmButtonText: 'OK',
    confirmButtonColor: '#16a34a',
  });

export const showWarning = (title: string, text?: string) =>
  Swal.fire({
    icon: 'warning',
    title,
    text,
    confirmButtonText: 'OK',
    confirmButtonColor: '#d97706',
  });

export const showInfo = (title: string, text?: string) =>
  Swal.fire({
    icon: 'info',
    title,
    text,
    confirmButtonText: 'OK',
    confirmButtonColor: '#d97706',
  });

export const showConfirm = (title: string, text?: string, confirmText = 'Oui', cancelText = 'Annuler') =>
  Swal.fire({
    icon: 'question',
    title,
    text,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: '#d97706',
    cancelButtonColor: '#c5c0c0',
  });
